import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const MobileSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 30 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M20.2054 0.817871H18.1693H10.8307H8.79463C7.46979 0.817871 6.39221 1.93261 6.39221 3.30313V26.6968C6.39221 28.0673 7.46979 29.1821 8.79463 29.1821H20.2054C21.5302 29.1821 22.6078 28.0673 22.6078 26.6968V3.30313C22.6078 1.93261 21.5302 0.817871 20.2054 0.817871ZM16.9207 1.75577L16.4384 3.2905H12.5616L12.0793 1.75577H16.9207ZM21.7012 26.6968C21.7012 27.5495 21.0296 28.2442 20.2054 28.2442H8.79463C7.97042 28.2442 7.29884 27.5495 7.29884 26.6968V3.30313C7.29884 2.4505 7.97042 1.75577 8.79463 1.75577H11.1268L11.9022 4.2284H17.0978L17.8762 1.75577H20.2084C21.0326 1.75577 21.7042 2.4505 21.7042 3.30313V26.6968H21.7012ZM11.4962 26.4221H17.5068V27.36H11.4962V26.4221Z'
      fill='currentColor'
    />
    <rect x='6.67023' y='1.13818' width='15.6596' height='27.7234' rx='1.5' stroke='currentColor' />
  </svg>
);

export const MobileIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={MobileSvg} {...props} />
);
